// Third Party
import React from 'react';
import Nullable from '@/types/nullable';

type Props = {
  className?: string;
  elements: Array<Nullable<JSX.Element>>;
};

const Card = ({ className, elements }: Props) => {
  const renderCardElements = () => elements.map((element, index) => <div key={index}>{element}</div>);

  const style = {
    border: '0.85px solid #e8e8e8',
    borderRadius: '6px',
    padding: '12px 24px',
    height: '100%',
  };

  return (
    <div className={className} style={style}>
      {renderCardElements()}
    </div>
  );
};

export type CardProps = Props;

export default Card;
